import React from "react";
import { SvgIcon } from "@/core/components/svgIcon/SvgIcon";
import { imageList } from "@/core/utils/imageList";

interface InvitationsSectionProps {
  invitations: Record<string, any>;
  loading: boolean;
  withdrawingInvitation: string | null;
  onWithdraw: (actionId: string, userId: string) => void;
}

export const InvitationsSection: React.FC<InvitationsSectionProps> = ({
  invitations,
  loading,
  withdrawingInvitation,
  onWithdraw,
}) => {
  if (loading) {
    return <div className="text-center py-4">Loading...</div>;
  }

  if (!invitations || Object.keys(invitations).length === 0) {
    return null;
  }

  return (
    <div className="tab-row invitations-to-join">
      <div className="tab-row-texts">
        <label>Invitations to join</label>
        Manage pending invitations for users to join your idea
      </div>
      <div className="invitation-list">
        <div className="invitations-content">
          <div className="invitations-section">
            <div className="space-y-3">
              {Object.entries(invitations).map(
                ([partnerId, invitationData]: [string, any]) => {
                  const userActionsArray = Object.entries(
                    invitationData.user_actions
                  ).map(([actionId, userData]: [string, any]) => ({
                    actionId,
                    ...userData,
                  }));

                  return userActionsArray.map((userAction) => (
                    <div
                      key={`invitation-${userAction.actionId}`}
                      className="invitation-item-grid invitation-item-sent"
                    >
                      <div className="invitation-avatar">
                        <img
                          src={
                            userAction.user_data?.logo_uri || imageList.noimage
                          }
                          alt={userAction.user_data?.firstname || "User"}
                          className="invitation-avatar-img"
                          onError={(e) => {
                            const target = e.target as HTMLImageElement;
                            target.src = imageList.noimage;
                          }}
                        />
                      </div>

                      <div className="invitation-info">
                        <div className="invitation-title">
                          {userAction.user_data?.firstname &&
                          userAction.user_data?.lastname
                            ? `${userAction.user_data.firstname} ${userAction.user_data.lastname}`
                            : userAction.user_data?.email || "Unknown User"}
                        </div>
                        <div className="invitation-subtitle">
                          {userAction.user_data?.job_title ||
                            userAction.user_data?.description ||
                            "Invited user"}
                        </div>
                        <div className="partner-info">
                          Partner:{" "}
                          {invitationData.partner?.title || "Unknown Partner"}
                        </div>
                      </div>

                      <div className="invitation-actions">
                        <button
                          className="btn-withdraw-invitation"
                          onClick={() =>
                            onWithdraw(
                              userAction.actionId,
                              userAction.user_data?.id
                            )
                          }
                          disabled={
                            withdrawingInvitation === userAction.actionId
                          }
                        >
                          <SvgIcon icon="icon-withdraw" />
                          <span>
                            {withdrawingInvitation === userAction.actionId
                              ? "Withdrawing..."
                              : "Withdraw invitation"}
                          </span>
                        </button>
                      </div>
                    </div>
                  ));
                }
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
